import { FC } from 'react'
import { EditButton, EditButtonIcon } from './styled'
import { TButtonProps } from './types'

const Button: FC<TButtonProps> = ({ width = 36, height = width, onClick }) => {
   return (
      <EditButton onClick={onClick} width={width} height={height}>
         <EditButtonIcon />
      </EditButton>
   )
}

export default Button
